module.exports = __webpack_public_path__ + "static/media/hente.802b2fca.m4a";